<template>
  <div>
    <vue-element-loading :active="status === 'loading'" />

    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-bus-side </v-icon>
        <span class="pl-2">{{ $t('pages.rides') }}</span>
      </v-card-title>

      <v-card-text>{{ $t('pages.buses') }}</v-card-text>
      <v-card-text style="display: flex; flex-direction: column">
        <!--        <p>-->
        <!--          Download app to start a ride, if you dont have app installed you cant-->
        <!--          start a ride:-->
        <!--        </p>-->
        <!--        <a href="https://bustracker-ws.unibatech.net/bustracker-app.apk">-->
        <!--          Android app-->
        <!--        </a>-->
        <!--        <p>-->
        <!--          Së shpejti do të keni qasje në hartë për të ndjekur lëvizjet në kohë-->
        <!--          reale.-->
        <!--        </p>-->
      </v-card-text>
    </v-card>

    <div class="buses my-4">
      <v-card class="col-md-4" v-for="bus in buses" :key="bus.id">
        <v-card-title class="pb-0"> {{ bus.name }} </v-card-title>

        <v-card-text class="text--primary">
          <div>{{ $t('table.license') }}: {{ bus.license }}</div>

          <div>{{ $t('table.capacity') }}: {{ bus.capacity }}</div>

          <div>{{ $t('table.students') }}: {{ bus.students_count }}</div>
        </v-card-text>

        <v-card-actions>
          <div>
            <v-btn
              color="success"
              type="button"
              :loading="status === 'loading-start-' + bus.id"
              @click="startRide(bus.id)"
              :disabled="!!bus.started_ride"
            >
              {{ $t('actions.start') }}
            </v-btn>
            <p
              v-if="bus.started_ride"
              class="caption"
              style="margin: 0; padding: 0"
            >
              {{ $t('messages.bus_is_in_use_by_other_drivers') }}
            </p>
          </div>

          <!--          <v-btn color="error" type="button">Cancel</v-btn>-->
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';

export default {
  components: {
    VueElementLoading,
  },
  data() {
    return {
      status: '',
      buses: [],
      startedRide: false,
    };
  },
  mounted() {
    this.getDriverBuses();
    this.getStartedRide();
  },
  methods: {
    getDriverBuses() {
      this.status = 'loading';
      this.rides = [];
      axios
        .get(`/buses/driver-buses`)
        .then((response) => {
          this.buses = response?.data;
        })
        .catch(() => {
          this.buses = [];
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_buses'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
    getStartedRide() {
      axios
        .get(`/rides/started`)
        .then((response) => {
          this.startedRide = response?.data;
        })
        .catch(() => {
          this.startedRide = null;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_started_ride'),
            type: 'error',
          });
          // this.$swal( this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {});
    },
    startRide(bus_id) {
      this.status = 'loading-start-' + bus_id;
      axios
        .post(`/rides/start`, { bus_id })
        .then(() => {
          // this.startedRide = response?.data;
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.success_started_ride'),
            type: 'success',
          });
          // this.$swal('Success', 'Success started ride', 'success');
          this.getStartedRide();
        })
        .catch((error) => {
          const message = error?.response?.data?.message;
          const code = error?.response?.data?.code;
          if (message === 'Start location in your app' && code === 400) {
            this.$swal('Error', message, 'error');
            return;
          }
          this.startedRide = null;
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_starting_ride'),
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.status = '';
        });
    },
  },
  watch: {
    startedRide: function (newValue) {
      if (newValue?.id) {
        this.$router.push({
          name: 'driver-view-rides',
          params: {
            ride_id: newValue?.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
//.buses {
//  width: 100%;
//  margin-block: 18px;
//  display: flex;
//  flex-wrap: wrap;
//  gap: 15px;
//
//  .bus {
//    min-width: max(32%, 300px);
//  }
//}
.buses {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

@media (max-width: 850px) {
  .buses {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 600px) {
  .buses {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
